var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-select',{attrs:{"value":_vm.year,"placeholder":_vm.$t('PaycheckReport.year'),"full-size":false,"options":_vm.years,"inline":""},on:{"input":_vm.addYearToUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }